/**
 * ページトップへスクロール機能
 * フッターのTOPボタンをクリックするとページトップへスムーズにスクロール
 */
export const scrollTop = () => {
  const topButton = document.querySelector('.js-scroll-top');

  if (!topButton) {
    return;
  }

  topButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
};
